import { PopupModal, ConfirmationModal, TableModal } from './components';

export const Modals = {
  PopupModal,
  ConfirmationModal,
  TableModal,
};
